import { Component } from 'react';

/**
 * Last line of defence: a render error shows a readable message instead of a
 * blank cream page. Copy is passed in rather than translated here, because the
 * boundary sits ABOVE the locale provider — if the provider is what threw, there
 * is no `t()` to call.
 */
export default class AppErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Unhandled render error:', error, errorInfo);
    }

    render() {
        const { children, title, body } = this.props;

        if (!this.state.hasError) {
            return children;
        }

        return (
            <div className="app-error" role="alert">
                <h1>{title}</h1>
                <p>{body}</p>
            </div>
        );
    }
}
